import { render } from "./AwardPage.vue?vue&type=template&id=7dd8820b&scoped=true"
import script from "./AwardPage.vue?vue&type=script&lang=js"
export * from "./AwardPage.vue?vue&type=script&lang=js"

import "./AwardPage.vue?vue&type=style&index=0&id=7dd8820b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd8820b"]])

export default __exports__